import { useApiRead } from "source/shared/SessionApiResource"

const COUNTRY_OPTIONS_PATH = "/people/v2/countries"

export function useCountryOptions() {
  const { data } = useApiRead(COUNTRY_OPTIONS_PATH)
  return data
}
